import React from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import "./take-control.css";

const TakeControl = () => {
  const navigate = useNavigate();

  // Animation variants for consistency with other sections
  const sectionVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: { staggerChildren: 0.2, delayChildren: 0.1 },
    },
  };

  const textVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { type: "spring", stiffness: 100 },
    },
  };
  
  const imageVariants = {
    hidden: { opacity: 0, scale: 0.9 },
    visible: {
      opacity: 1,
      scale: 1,
      transition: { duration: 0.5, ease: "easeOut" },
    },
  };

  const buttonVariants = {
    hover: {
      scale: 1.05,
      transition: { duration: 0.2 },
    },
    tap: {
      scale: 0.95,
      transition: { duration: 0.1 },
    },
  };

  return (
    <motion.section
      className="take-control-section"
      variants={sectionVariants}
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, amount: 0.3 }}
    >
      <div className="take-control-content">
        <motion.div className="take-control-text" variants={textVariants}>
          <h2>Take Control of Your Health Today</h2>
          <p>
            Order genomics tests with Direct by Syndicate Bio and get the
            insights you need to make informed health decisions.
          </p>
          <motion.button
            className="take-control-button"
            onClick={() => navigate("/login")}
            variants={buttonVariants}
            whileHover="hover"
            whileTap="tap"
          >
            Get started
          </motion.button>
        </motion.div>
        <motion.div className="take-control-image-container" variants={imageVariants}>
          <img
            src={`${process.env.PUBLIC_URL}/assets/take-control-img.png`}
            alt="Mother and child smiling with joy"
            className="take-control-image"
          />
        </motion.div>
      </div>
    </motion.section>
  );
};

export default TakeControl;